export const TIPOS_PLANTILLA_CONTRATO = [
  { id: 'CREDITO', label: 'Crédito' },
  { id: 'CONTADO', label: 'Contado' },
];

export const CATEGORIAS_VARIABLES_CONTRATO = [
  {
    categoria: 'Cliente / Comprador',
    variables: [
      { label: 'Nombre Completo del Cliente', clave: 'NombreCliente' },
      { label: 'Domicilio del Cliente', clave: 'DomicilioConv' },
      { label: 'RFC del Cliente', clave: 'rfcComprador' },
      { label: 'CURP del Cliente', clave: 'curpComprador' },
      { label: 'Código Postal del Cliente', clave: 'cpComprador' },
      { label: 'Nacionalidad del Cliente', clave: 'nacionalidadComprador' },
      { label: 'Lugar de Nacimiento / Origen', clave: 'lugarOrigenComprador' },
      { label: 'Estado de Nacimiento', clave: 'estadoComprador' },
      { label: 'Estado Civil del Cliente', clave: 'estadoCivilComprador' },
      { label: 'Profesión u Ocupación', clave: 'ocupacionComprador' },
      { label: 'Día de Nacimiento (Número)', clave: 'diaNacimientoCliente' },
      { label: 'Mes de Nacimiento (Texto)', clave: 'mesNacimientoCliente' },
      { label: 'Año de Nacimiento (Número)', clave: 'anioNacimientoCliente' },
      { label: 'Día de Nacimiento en Letra', clave: 'diaNacimientoClienteLetra' },
      { label: 'Año de Nacimiento en Letra', clave: 'anioNacimientoClienteLetra' },
      { label: 'Nombre para Firma del Cliente', clave: 'CompradorFirma' },
    ],
  },
  {
    categoria: 'Lote / Terreno',
    variables: [
      { label: 'Número de Lote', clave: 'NomLote' },
      { label: 'Número de Lote en Letras', clave: 'lote.numeroLetra' },
      { label: 'Manzana', clave: 'NomManzana' },
      { label: 'Manzana en Letras', clave: 'NomManzanaLetra' },
      { label: 'Área / Superficie (m²)', clave: 'AreaLote' },
      { label: 'Área / Superficie en Letras', clave: 'AreaLoteLetras' },
      { label: 'Frente en Letras', clave: 'lote.frenteLetra' },
      { label: 'Fondo en Letras', clave: 'lote.fondoLetra' },
      { label: 'Lateral Izquierdo en Letras', clave: 'lote.lateralIzquierdoLetra' },
      { label: 'Lateral Derecho en Letras', clave: 'lote.lateralDerechoLetra' },
      { label: 'Colindancia Norte Completa', clave: 'LoteNorteInfo' },
      { label: 'Colindancia Sur Completa', clave: 'LoteSurInfo' },
      { label: 'Colindancia Este Completa', clave: 'LoteEsteInfo' },
      { label: 'Colindancia Oeste Completa', clave: 'LoteOesteInfo' },
      { label: 'Calle Norte', clave: 'lote.calleNorte' },
      { label: 'Calle Sur', clave: 'lote.calleSur' },
      { label: 'Calle Este', clave: 'lote.calleEste' },
      { label: 'Calle Oeste', clave: 'lote.calleOeste' },
      { label: 'Ubicación Física del Lote', clave: 'lote.ubicacion' },
      { label: 'Tipo de Inmueble (Categoría)', clave: 'TipoInmueble' },
    ],
  },
  {
    categoria: 'Proyecto / Predio Mayor',
    variables: [
      { label: 'Nombre del Proyecto', clave: 'NomProyecto' },
      { label: 'Descripción del Proyecto / Predio', clave: 'desProyecto' },
      { label: 'Superficie Total del Proyecto', clave: 'proyectoSuperficie' },
    ],
  },
  {
    categoria: 'Empresa / Vendedor',
    variables: [
      { label: 'Nombre de la Empresa (Vendedor)', clave: 'Vendedor' },
      { label: 'Razón Social de la Empresa', clave: 'empresa.razonSocial' },
    ],
  },
  {
    categoria: 'Representante Legal',
    variables: [
      { label: 'Nombre del Representante', clave: 'Representante' },
      { label: 'Domicilio del Representante', clave: 'domicilioRepresentante' },
      { label: 'Ciudad del Representante', clave: 'ciudadRepresentante' },
      { label: 'Estado / Entidad del Representante', clave: 'entidadRepresentante' },
      { label: 'Ocupación del Representante', clave: 'ocupacionRepresentante' },
      { label: 'Estado Civil del Representante', clave: 'estadoCivilRepresentante' },
      { label: 'Día de Nacimiento Representante', clave: 'diaNacimientoRepresentante' },
      { label: 'Mes de Nacimiento Representante', clave: 'mesNacimientoRepresentante' },
      { label: 'Año de Nacimiento Representante', clave: 'anioNacimientoRepresentante' },
    ],
  },
  {
    categoria: 'Financiamiento y Montos',
    variables: [
      { label: 'Precio Convenido ($ y Letra)', clave: 'PrecioConvenido' },
      { label: 'Enganche / Anticipo ($ y Letra)', clave: 'Enganche' },
      { label: 'Saldo a Financiar ($ y Letra)', clave: 'SaldoOperacion' },
      { label: 'Pago Mensual ($ y Letra)', clave: 'PagoMensual' },
      { label: 'Plazo en Meses (Número)', clave: 'PlazoMes' },
      { label: 'Plazo en Años y Meses en Letra', clave: 'PlazoAniosMeses' },
      { label: 'Interés Moratorio en Letra', clave: 'porcentajeInteresMoratorioLetra' },
    ],
  },
  {
    categoria: 'Fechas y Formalización',
    variables: [
      { label: 'Fecha de Contrato Completa en Texto', clave: 'fechaInicio' },
      { label: 'Día de Firma', clave: 'diaFirma' },
      { label: 'Mes de Firma', clave: 'mesFirma' },
      { label: 'Año de Firma', clave: 'anioFirma' },
      { label: 'Testigo 1', clave: 'testigo1' },
      { label: 'Testigo 2', clave: 'testigo2' },
      { label: 'Hora de Inicio', clave: 'horaInicio' },
      { label: 'Hora de Fin', clave: 'horaFin' },
    ],
  },
];
